/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */

/**
 * TextBlockStatus component types
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.10.0
 */

export enum ETextBlockStatus {
    ERROR = 'ERROR',
    OK = 'OK',
    PARTIALLY = 'PARTIALLY',
    WARNING = 'WARNING',
    CHANGE = 'CHANGE',
}
